<div
  class="font-main text-base font-bold p-3 rounded-0.75"
  [ngClass]="getDynamicClasses()"
>
  <ng-content></ng-content>
</div>

@if (selected && selectHighlight) {
  <div class="absolute rounded-r-md w-1 top-0 left-0 h-full bg-blue-50"></div>
}
